import { MRT_ColumnDef } from 'mantine-react-table'
import { Badge, NumberFormatter, Text } from '@mantine/core'
import { PillAlert } from '@shared/components/pill-alert/pill-alert'
import { LoomWoolLotOfferStatus, UnsoldLot } from '@loom-api-types'
import { OfferStatusDisplay } from '@shared/components/offers/offer-status-display/offer-status-display'

export const unsoldLotsColumns: MRT_ColumnDef<UnsoldLot>[] = [
  {
    id: 'season',
    accessorKey: 'season',
    header: 'Season',
    enableColumnFilter: true,
    filterVariant: 'select',
  },
  {
    id: 'saleNumber',
    accessorKey: 'saleNumber',
    header: 'Sale',
    enableColumnFilter: true,
    filterVariant: 'select',
  },
  {
    id: 'porg',
    accessorFn: (row) =>
      row.stationRecordNumber ? `${row.stationBrand} ${row.stationRecordNumber}` : '',
    header: 'P Org',
    enableColumnFilter: true,
    filterVariant: 'select',
  },
  {
    id: 'internalReferenceCode',
    accessorKey: 'internalReferenceCode',
    header: 'Reference',
    enableColumnFilter: true,
    Cell: ({ row }) => (
      <>
        <Text size='sm'>{row.original.internalReferenceCode}</Text>
        {row.original.interlotWarning && (
          <Badge color='gray' variant='light' c='black' fw={600} aria-label='Interlot Part'>
            IP
          </Badge>
        )}
      </>
    ),
  },
  {
    id: 'code',
    accessorKey: 'code',
    header: 'Lot No',
    enableColumnFilter: false,
  },
  {
    id: 'totalBales',
    accessorKey: 'totalBales',
    header: 'Bales',
    enableColumnFilter: false,
    mantineTableHeadCellProps: {
      align: 'right',
    },
    mantineTableBodyCellProps: {
      align: 'right',
    },
    mantineTableFooterCellProps: {
      align: 'right',
    },
  },
  {
    id: 'mainBaleHeaderPurchaseDescription',
    accessorKey: 'mainBaleHeaderPurchaseDescription',
    header: 'Description',
    enableColumnFilter: false,
  },
  {
    id: 'typeCurrent',
    accessorKey: 'typeCurrent',
    header: 'Type',
    enableColumnFilter: false,
  },
  {
    id: 'internalComment',
    accessorKey: 'internalComment',
    header: 'Comment',
    enableColumnFilter: false,
  },
  {
    id: 'coreTestMicron',
    accessorKey: 'coreTestMicron',
    header: 'Mic',
    enableColumnFilter: false,
    Cell: ({ cell }) => (
      <NumberFormatter value={cell.getValue<number>() ?? ''} thousandSeparator decimalScale={1} />
    ),
  },
  {
    id: 'coreTestVegetableMatterBase',
    accessorKey: 'coreTestVegetableMatterBase',
    header: 'VM',
    enableColumnFilter: false,
    Cell: ({ cell }) => (
      <NumberFormatter value={cell.getValue<number>() ?? ''} thousandSeparator decimalScale={1} />
    ),
  },
  {
    id: 'coreTestYield',
    accessorKey: 'coreTestYield',
    header: 'YLD',
    enableColumnFilter: false,
    Cell: ({ cell }) => (
      <NumberFormatter value={cell.getValue<number>() ?? ''} thousandSeparator decimalScale={1} />
    ),
  },
  {
    id: 'coreTestColourYZ',
    accessorKey: 'coreTestColourYZ',
    header: 'Col',
    enableColumnFilter: false,
    Cell: ({ cell }) => (
      <NumberFormatter value={cell.getValue<number>() ?? ''} thousandSeparator decimalScale={1} />
    ),
  },
  {
    id: 'coreTestStapleLengthGreasy',
    accessorKey: 'coreTestStapleLengthGreasy',
    header: 'SL',
    enableColumnFilter: false,
    Cell: ({ cell }) => (
      <NumberFormatter value={cell.getValue<number>() ?? ''} thousandSeparator decimalScale={0} />
    ),
  },
  {
    id: 'coreTestStapleStrength',
    accessorKey: 'coreTestStapleStrength',
    header: 'SS',
    enableColumnFilter: false,
    Cell: ({ cell }) => (
      <NumberFormatter value={cell.getValue<number>() ?? ''} thousandSeparator decimalScale={0} />
    ),
  },
  {
    id: 'purchaseAccountName',
    accessorKey: 'purchaseAccountName',
    header: 'P Acc Name',
    enableColumnFilter: false,
  },
  {
    id: 'qualityScheme2',
    accessorKey: 'qualityScheme2',
    header: 'Cert',
    enableColumnFilter: false,
    Cell: ({ row }) => (
      <>
        <Text size='sm' c={row.original.qualitySchemeWarning ? 'red.9' : ''}>
          {row.original.qualityScheme2}
        </Text>
        {row.original.qualitySchemeWarning && <PillAlert text='Cert' />}
      </>
    ),
  },
  {
    id: 'status',
    accessorKey: 'status',
    enableColumnFilter: false,
    header: 'Status',
    Cell: ({ cell }) => (
      <>
        <OfferStatusDisplay
          loomWoolLotOfferStatus={cell.getValue<LoomWoolLotOfferStatus | undefined>()}
        />
      </>
    ),
  },
]
